import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

interface Option {
  value: string;
  label: string;
}

/**
 * Creatives selectable in the creative report, for one ad group.
 *
 * Backed by the dedicated options query rather than the paginated `creatives`
 * list: that one defaults to a page size of 10, so an ad group with more than
 * ten creatives silently offered only the first ten. The options query is
 * unpaginated, and it also returns deleted creatives that have play history —
 * deleting a creative now detaches it from every playlist, but its play logs
 * survive, so its report is still worth reaching. Those come back labelled
 * "(deleted)".
 */
export const useCreativesByAdGroup = (adGroupId: string | null) => {
  const {
    data: creativeOptions,
    isLoading,
    error,
    refetch,
  } = useQuery<Option[], Error>({
    queryKey: ["creativeReportOptions", adGroupId],
    queryFn: () => dropdownService.getCreativeReportOptions(adGroupId as string),
    enabled: !!adGroupId,
  });

  return {
    creativeOptions: creativeOptions || [],
    isLoading,
    error,
    refetch,
  };
};
